"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Triangle = exports.IsPointInShape = exports.ShapeHelper = exports.Rectangle = exports.glMatrixSetup = exports.Ellipse = exports.Contour = exports.Circle = void 0;
var Circle_1 = require("./lib/Circle");
Object.defineProperty(exports, "Circle", { enumerable: true, get: function () { return Circle_1.Circle; } });
var Contour_1 = require("./lib/Contour");
Object.defineProperty(exports, "Contour", { enumerable: true, get: function () { return Contour_1.Contour; } });
var Ellipse_1 = require("./lib/Ellipse");
Object.defineProperty(exports, "Ellipse", { enumerable: true, get: function () { return Ellipse_1.Ellipse; } });
var gl_matrix_setup_1 = require("./lib/gl-matrix.setup");
Object.defineProperty(exports, "glMatrixSetup", { enumerable: true, get: function () { return gl_matrix_setup_1.glMatrixSetup; } });
var Rectangle_1 = require("./lib/Rectangle");
Object.defineProperty(exports, "Rectangle", { enumerable: true, get: function () { return Rectangle_1.Rectangle; } });
var ShapeHelper_1 = require("./lib/ShapeHelper");
Object.defineProperty(exports, "ShapeHelper", { enumerable: true, get: function () { return ShapeHelper_1.ShapeHelper; } });
Object.defineProperty(exports, "IsPointInShape", { enumerable: true, get: function () { return ShapeHelper_1.IsPointInShape; } });
var Triangle_1 = require("./lib/Triangle");
Object.defineProperty(exports, "Triangle", { enumerable: true, get: function () { return Triangle_1.Triangle; } });
//# sourceMappingURL=index.js.map